import React from "react";
import { Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import { updateUsers } from "../../../../Redux/Slices/users.slice";
import capitalize from "../../../../Utils/capitalize";

const Tag = ({ text = "" }) => {
  return (
    <div className="bg-primary-10 py-1 px-2 max-h-[26px] rounded-md max-w-max">
      <p className="font-poppins font-medium text-xs text-primary">{text}</p>
    </div>
  );
};

const LabelAndValue = ({ label = "", value = "", shouldCapitalize = true }) => {
  return (
    <div className="flex-1 font-poppins">
      <p
        className="font-medium text-sm"
        style={{ textTransform: shouldCapitalize && "capitalize" }}
      >
        {value || "--"}
      </p>
      <p className="font-normal text-xs text-dark-gray">{label}</p>
    </div>
  );
};

const PartnerDetailDrawer = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const { partnerDetailDrawer } = useSelector((state) => state.users);

  const data = partnerDetailDrawer?.data || {};

  const handleViewID = () => {
    if (data?.idUrl) {
      dispatch(
        updateUsers({
          key: "licenseModal",
          value: {
            visible: true,
            url: data?.idUrl || "",
            type: "partner",
          },
        }),
      );

      return;
    }

    dispatch(
      updateUsers({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "No ID Found",
            description: `ID not found for partner ${capitalize(
              data?.firstName,
            )} ${capitalize(data?.lastName)}`,
            type: "error",
          },
        },
      }),
    );
  };

  const getNumber = (type) => {
    if (type === "contact") {
      if (data?.contactNo) {
        if (data?.hasExtension) return `+${data?.contactNo}`;
        return `+254${data?.contactNo}`;
      }

      return "--";
    }
    if (type === "mpesa") {
      if (data?.mpesaNo) {
        if (data?.hasExtension) return `+${data?.mpesaNo}`;
        return `+254${data?.mpesaNo}`;
      }

      return "--";
    }

    return "--";
  };

  return (
    <Drawer
      width={560}
      placement="right"
      closable={false}
      maskStyle={{
        background: "transparent",
        boxShadow: "12px 12px 16px -4px #10182814",
      }}
      open={visible}
      onClose={onCancel}
      className="rounded-tl-xl"
    >
      <div className="p-6 w-full h-full bg-background-white rounded-tl-xl relative">
        <div className="flex items-center justify-between">
          <p className="font-poppins font-medium text-base text-black">
            Partner Details
          </p>

          <CloseIcon
            className="w-5 h-5 cursor-pointer stroke-dark-grey-text"
            onClick={onCancel}
          />
        </div>

        <div className="mt-6 px-6 py-4 border border-light-grey rounded-xl">
          <Tag text="General" />

          <div className="mt-4 flex items-center gap-x-4">
            <LabelAndValue label="First Name" value={data?.firstName} />

            <LabelAndValue label="Last Name" value={data?.lastName} />
          </div>

          <div className="mt-4 flex items-center gap-x-4">
            <LabelAndValue label="Gender" value={data?.gender} />

            <LabelAndValue
              label="Contact Number"
              value={getNumber("contact")}
            />
          </div>

          <div className="mt-4 flex items-center gap-x-4">
            <LabelAndValue label="M-Pesa Number" value={getNumber("mpesa")} />
            <LabelAndValue label="Hub Station" value={data?.hubName} />
          </div>
        </div>

        <div className="mt-6 px-6 py-4 border border-light-grey rounded-xl">
          <Tag text="Identification" />

          <div className="mt-4 flex items-center gap-x-4">
            <LabelAndValue
              label="Unique ID"
              value={data?.uniqueId}
              shouldCapitalize={false}
            />

            <div className="flex-1">
              <button
                type="button"
                className="py-[11px] px-4 bg-primary hover:bg-primary-50 rounded-md"
                onClick={handleViewID}
              >
                <p className="font-poppins font-medium text-xs text-white">
                  View ID
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default PartnerDetailDrawer;
